'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindMethods = bindMethods;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Utility method for binding methods in component constructors
 * @param  {Object} context context to bind to
 * @param  {Array} methods  methods The array of method names
 * @return {Undefined} Returns nothing
 */
function bindMethods(context, methods) {
  _lodash2.default.forEach(methods, function (method) {
    if (_lodash2.default.isFunction(context[method])) {
      context[method] = context[method].bind(context);
    }
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL1V0aWxzL2JpbmRNZXRob2RzLmpzIl0sIm5hbWVzIjpbImJpbmRNZXRob2RzIiwiY29udGV4dCIsIm1ldGhvZHMiLCJfIiwiZm9yRWFjaCIsImlzRnVuY3Rpb24iLCJtZXRob2QiLCJiaW5kIl0sIm1hcHBpbmdzIjoiOzs7OztRQVFnQkEsVyxHQUFBQSxXOztBQVJoQjs7Ozs7O0FBRUE7Ozs7OztBQU1PLFNBQVNBLFdBQVQsQ0FBc0JDLE9BQXRCLEVBQStCQyxPQUEvQixFQUF3QztBQUM3Q0MsbUJBQUVDLE9BQUYsQ0FBVUYsT0FBVixFQUFtQixrQkFBVTtBQUMzQixRQUFJQyxpQkFBRUUsVUFBRixDQUFhSixRQUFRSyxNQUFSLENBQWIsQ0FBSixFQUFtQztBQUNqQ0wsY0FBUUssTUFBUixJQUFrQkwsUUFBUUssTUFBUixFQUFnQkMsSUFBaEIsQ0FBcUJOLE9BQXJCLENBQWxCO0FBQ0Q7QUFDRixHQUpEO0FBS0QiLCJmaWxlIjoiYmluZE1ldGhvZHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgXyBmcm9tICdsb2Rhc2gnO1xuXG4vKipcbiAqIFV0aWxpdHkgbWV0aG9kIGZvciBiaW5kaW5nIG1ldGhvZHMgaW4gY29tcG9uZW50IGNvbnN0cnVjdG9yc1xuICogQHBhcmFtICB7T2JqZWN0fSBjb250ZXh0IGNvbnRleHQgdG8gYmluZCB0b1xuICogQHBhcmFtICB7QXJyYXl9IG1ldGhvZHMgIG1ldGhvZHMgVGhlIGFycmF5IG9mIG1ldGhvZCBuYW1lc1xuICogQHJldHVybiB7VW5kZWZpbmVkfSBSZXR1cm5zIG5vdGhpbmdcbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIGJpbmRNZXRob2RzIChjb250ZXh0LCBtZXRob2RzKSB7XG4gIF8uZm9yRWFjaChtZXRob2RzLCBtZXRob2QgPT4ge1xuICAgIGlmIChfLmlzRnVuY3Rpb24oY29udGV4dFttZXRob2RdKSkge1xuICAgICAgY29udGV4dFttZXRob2RdID0gY29udGV4dFttZXRob2RdLmJpbmQoY29udGV4dCk7XG4gICAgfVxuICB9KTtcbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./node_modules/legacy-advertising/dist/Utils/bindMethods.js
// module id = 598
// module chunks = 0